import React from 'react';
import './landingTitle.css';

const LandingHeading = () => (
  <header className="landing-section">
    <div className="landing-title">
      <div className="text-top">
        <div>
          <span>Kartik</span>
          <span>Choudhary</span>
        </div>
      </div>
      <div className="text-bottom">
        <div>Software Engineer</div>
      </div>
    </div>
  </header>
);

export default LandingHeading;
